import { Component } from '@angular/core';

@Component({
    selector: 'app-copyright-bar',
    templateUrl: './copyright-bar.component.html',
    standalone: true
})
export class CopyrightBarComponent {
    readonly currentYear = new Date().getFullYear();
}
